import { JwtCustonService } from './../auth/jwtCustomService';
import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpResponse,
    HttpErrorResponse,
} from '@angular/common/http';
import { from, Observable, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { NotificationsService } from 'angular2-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { OAuthService } from 'angular-oauth2-oidc';
import { LoaderService } from './loader.service';

@Injectable()
export class RequestInterceptorService implements HttpInterceptor {
    constructor(
        private notificationsService: NotificationsService,
        private spinner: NgxSpinnerService,
        private oauthService: OAuthService,
        public loaderService: LoaderService,
        private jwtCustonService: JwtCustonService,
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.headers.get('authorization') == null && this.jwtCustonService.Token != null) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${this.jwtCustonService.Token}`,
                },
            });
        }

        return next.handle(request).pipe(
            tap((event: any) => {
                if (event instanceof HttpResponse) {
                    if (event.body && event.body.message) {
                        const exeptionUrl = event?.url?.indexOf('count');

                        if (exeptionUrl === -1) {
                            this.veryfyTypeNotify(event.body.typeResponse, event.body.message);
                        }
                    }
                }
            }),

            catchError((error: HttpErrorResponse) => {
                this.spinner.hide();
                this.loaderService.hide();

                // Trata erros de endpoints com responseType: 'blob'
                if (error.error instanceof Blob) {
                    return from(error.error.text()).pipe(
                        switchMap((text: string) => {
                            try {
                                const parsedError = JSON.parse(text);

                                this.captureErrorMessage({
                                    ...error,
                                    error: parsedError,
                                });
                            } catch {
                                this.captureErrorMessage({
                                    ...error,
                                    error: text,
                                });
                            }

                            return throwError(() => error);
                        }),
                    );
                }
                this.captureErrorMessage(error);
                return throwError(() => error);
            }),
        );
    }

    logoutConnection() {
        this.oauthService.logOut(true);
        this.jwtCustonService.logout();
        console.log('tryConnectAgain');
    }

    async captureErrorMessage(result: any) {
        switch (result.status) {
            case 0:
                this.notificationsService.error(
                    'Atenção',
                    'Erro 154 - Serviço Indisponivel. Por favor tente Mais tarde!',
                );
                break;
            case 401:
                this.logoutConnection();
                break;

            case 400:
            case 500:
                var msg: any;
                if (!result.error.message) {
                    if (result.error.message !== undefined) {
                        msg = result.error.message;
                    }

                    let findError = result?.error?.errors;
                    if (findError && result.error.errors[0]) {
                        msg = result.error.errors[0];
                    } else {
                        if (result.error.Message) {
                            msg = result.error.Message;
                        } else {
                            if (result.error.toString().includes('ArrayBuffer')) {
                                console.error(result);
                                return;
                            } else if (result.error.message) {
                                msg = result.error.message;
                            } else if (result?.error) {
                                msg = result?.error;
                            } else {
                                msg = `houve um erro na solicitação ${result.message}`;
                            }
                        }
                    }
                } else {
                    msg = Array.isArray(result.error.message) ? result.error.message.join(' | ') : result.error.message;
                }

                if (msg) {
                    this.notificationsService.warn(msg);
                    console.error(msg);
                    break;
                } else {
                    this.notificationsService.error('Atenção', `Erro ao atender a solicitação ${result?.status}`);
                }

            default:
                var msg;

                if (!result.error.message) {
                    this.notificationsService.error('Atenção', 'Erro ao atender a solicitação');
                    break;
                }

                if (typeof result.error.message === 'string') {
                    msg = result.error.message;
                } else {
                    msg = result.error.message.join(' | ');
                }

                if (msg) {
                    this.notificationsService.error('Atenção', msg);
                } else {
                    this.notificationsService.error('Atenção', `Erro ao atender a solicitação ${result?.status}`);
                }
                break;
        }
    }

    veryfyTypeNotify(enumParam: string, msg: string) {
        switch (enumParam) {
            case '2':
                this.notificationsService.info('Atenção', msg);
                break;

            case '1':
                this.notificationsService.warn('Atenção', msg);
                break;

            case '3':
                this.notificationsService.success('', msg);
                break;

            case '0':
                this.notificationsService.error('Atenção', msg);
                break;
        }
    }
}
